import { EnumValue } from '../types/EnumType';

type SimNao = EnumValue;

export const SimNaoEnum: SimNao[] = [
  { codigo: 'S', descricao: 'Sim' },
  { codigo: 'N', descricao: 'Não' }
];
